module.exports = __webpack_public_path__ + "static/img/Bachelor_010706.85a17df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010706.jpg
// module id = 228
// module chunks = 0